import React from "react";
import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { getAllLookUpData } from "../../serviceCalls";
import { DeleteLookUp } from "../deleteLookUp/DeleteLookUp";
import {
  TableHead,
  TableCell,
  TableBody,
  Paper,
  Container,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { CustomTableCell } from "../TableComponents/TableCell";
import { CustomIconButton } from "../Buttons/IconButton";
import "../../images/namesort.png";
import "../../images/lookUp.png";
import "../../images/deleteButton.png";
import { useLocationContext } from "../../Hooks/CustomHooks";
import { useNavigate, useLocation } from "react-router-dom";
import { PageButton } from "../TableComponents/PageButton";
import { ProgressBar } from "../CustomProgressBar/ProgressBar";
import {
  StyledDeleteActionIconButton,
  StyledDeleteIcon,
  StyledEditActionButton,
  StyledLookUpIcon,
  StyledSortedIcon,
  StyledTable,
  StyledTableContainer,
  StyledTableDataRow,
  StyledTableHeader,
  StyledTableHeaderRow,
  StyledTableRow,
  StyledlookUpHeading,
  StyledError,
} from "./LookUpScreenStyles";
import { appInsights } from "../../ApplicationInsightsService";

const GetAllLookUpData = () => {
  const currentLocation = useLocationContext();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { instance, accounts } = useMsal();
  const [limit, setLimit] = useState(location.state ? location.state.limit : 5);
  const [pageNo, setPageNo] = useState(
    location.state ? location.state.pageNo : 1
  );
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [correlationId, setCorrelationId] = useState("");
  const [pipelineId, setPipelineId] = useState("");
  const [deleteOriginName, setDeleteLookupOriginName] = useState("");

  const [sortAscending, setSortAscending] = useState(true);
  const [startAt, setStartAt] = useState(1);
  const [endAt, setEndAt] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [noOfPages, setNoOfPages] = useState(0);
  const lookupproperties = [
    "PipelineMappingId",
    "FiletransferId",
    "originName",
    "containerName",
    "sourceFolderPath",
    "fileName",
    "fileType",
    "destinationFolderPath",
    "triggerName",
    "StartDateTime",
  ];
  const headers = [
    "Pipeline ID",
    "File Transfer ID",
    "Origin Name",
    "Container Name",
    "Source Folder Path",
    "File Name",
    "File Type",
    "Destination Folder Path",
    "Trigger Name",
    "Trigger Start DateTime",
  ];
  useEffect(() => {
    setLoading(true);
    RequestLookupData({ PageNo: parseInt(pageNo), Limit: parseInt(limit) });
  }, [limit, pageNo]);

  const navigate = useNavigate();

  const handleDeleteLookUp = (currentpipelineId, originName) => {
    appInsights.trackEvent({
      name: `handleDeleteLookUp method called for opening  delete Modal for deleting lookup`,
    });
    setPipelineId(currentpipelineId);
    setDeleteLookupOriginName(originName);
    setOpenDeleteModal(true);
  };

  const handleEditButtonClick = (lookupData) => {
    appInsights.trackEvent({
      name: `handleEditButtonClick method called for navigating to edit-lookup page`,
    });
    navigate("edit-lookup", {
      state: { lookupData: lookupData, pageNo: pageNo, limit: limit },
    });
  };

  const handleSort = () => {
    setLoading(true);
    if (sortAscending) {
      const sortedData = [...data].sort(
        (a, b) => b.PipelineMappingId - a.PipelineMappingId
      );
      setData(sortedData);
      setSortAscending(false);
    } else if (!sortAscending) {
      const sortedData = [...data].sort(
        (a, b) => a.PipelineMappingId - b.PipelineMappingId
      );
      setData(sortedData);
      setSortAscending(true);
    }
    setLoading(false);
  };
  const handleCloseButtonClick = (path) => {
    navigate(path);
  };

  async function RequestLookupData(payload) {
    try {
      appInsights.trackEvent({
        name: `RequestLookupData method called for getting all lookup data`,
      });
      setLoading(true);
      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      const accessToken = await tokenResponse.accessToken;
      const response = await getAllLookUpData(payload, accessToken);
      const apiresponse = response?.data;
      const lookUpRecords = response?.data.LookupDatas.map((item) => ({
        PipelineMappingId: item.PipelineMappingId,
        FiletransferId: item.FiletransferId,
        originName: item.originName,
        containerName: item.containerName,
        sourceFolderPath: item.sourceFolderPath,
        fileName: item.fileName,
        destinationFolderPath: item.destinationFolderPath,
        fileType: item.fileType,
        triggerType: item.triggerType,
        triggerName: item.triggerName,
        StartDateTime: item.StartDateTime,
      }));
      const totalRecords = apiresponse?.TotalCount
        ? apiresponse.TotalCount
        : totalCount;
      const noOfPages = Math.ceil(totalRecords / limit);
      const noOfRecordsCurrentPage = apiresponse?.LookupDatas.length;
      const startAt = (pageNo - 1) * limit + 1;
      const endAt = startAt + noOfRecordsCurrentPage - 1;
      setStartAt(startAt);
      setEndAt(endAt);
      setTotalCount(totalRecords);
      setNoOfPages(noOfPages);
      setData(lookUpRecords);
    } catch (error) {
      setHasError(true);
      setErrorMessage(error.message);
      setCorrelationId(error.response.headers["x-correlation-id"]);
    }
    setLoading(false);
  }

  return (
    <>
      {hasError ? (
        <StyledError>
          Error Occurred: {errorMessage}. Correlation Id: {correlationId}
        </StyledError>
      ) : (
        <Container>
          <Box sx={{ display: "inline-flex" }}>
            <StyledlookUpHeading>List Screen - Lookup</StyledlookUpHeading>
            <StyledLookUpIcon
              alt="LookUpIcon"
              src={require("../../images/lookUp.png")}
            />
          </Box>
          {loading ? (
            <ProgressBar />
          ) : (
            <StyledTableContainer component={Paper}>
              <StyledTable stickyHeader aria-label="sticky table">
                <TableHead>
                  <StyledTableHeaderRow>
                    {headers.map((element, index) =>
                      element === "Pipeline ID" ? (
                        <CustomTableCell
                          value={element}
                          id={element.key}
                          fontColor={"#666461"}
                        >
                          <StyledSortedIcon
                            onClick={() => handleSort()}
                            src={require("../../images/namesort.png")}
                          />
                        </CustomTableCell>
                      ) : (
                        <CustomTableCell
                          value={element}
                          fontColor={"#666461"}
                        />
                      )
                    )}
                    <CustomTableCell fontColor={"#666461"} value={"Actions"} />
                  </StyledTableHeaderRow>
                </TableHead>
                <TableBody>
                  {data?.map((item, index) => (
                    <StyledTableDataRow>
                      {lookupproperties.map((key, index) =>
                        key === "PipelineMappingId" ? (
                          <CustomTableCell
                            enableTootip={true}
                            value={item[key]}
                            fontColor={"secondary"}
                          ></CustomTableCell>
                        ) : key === "StartDateTime" ? (
                          <CustomTableCell
                            enableTootip={true}
                            value={
                              new Date(item[key]).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }) +
                              " " +
                              new Date(item[key])
                                .toLocaleTimeString("en-GB", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  hour12: true,
                                })
                                .toUpperCase()
                            } // Convert to datetime
                            tablekey={key}
                          ></CustomTableCell>
                        ) : (
                          <CustomTableCell
                            enableTootip={true}
                            value={item[key]}
                            tablekey={key}
                          ></CustomTableCell>
                        )
                      )}
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <StyledEditActionButton
                            onClick={() => handleEditButtonClick(item)}
                          >
                            <span>Edit</span>
                            <EditIcon sx={{ color: "#FAFAFA" }} />
                          </StyledEditActionButton>
                          <StyledDeleteActionIconButton
                            variant="contained"
                            onClick={() =>
                              handleDeleteLookUp(
                                item["PipelineMappingId"],
                                item["originName"]
                              )
                            }
                          >
                            <StyledDeleteIcon
                              src={require("../../images/deleteButton.png")}
                              alt="DeleteIcon"
                            ></StyledDeleteIcon>
                          </StyledDeleteActionIconButton>
                        </Box>
                      </TableCell>
                    </StyledTableDataRow>
                  ))}
                </TableBody>
              </StyledTable>
            </StyledTableContainer>
          )}
          <PageButton
            pageNo={pageNo}
            setPageNo={setPageNo}
            limit={limit}
            setLimit={setLimit}
            totalCount={totalCount}
            noOfPages={noOfPages}
            startAt={startAt}
            endAt={endAt}
          />
          <Box
            width="auto"
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              sx={{}}
              onClick={() => {
                handleCloseButtonClick("/");
              }}
            >
              Close
            </Button>
          </Box>
        </Container>
      )}
      <div>
        <DeleteLookUp
          openDeleteModal={openDeleteModal}
          setOpenDeleteModal={setOpenDeleteModal}
          pipelineMappingId={pipelineId}
          originname={deleteOriginName}
          pageNo={pageNo}
          limit={limit}
          setPageNo={setPageNo}
          setLimit={setLimit}
          totalCount={totalCount}
          RequestLookupData={RequestLookupData}
          startAt={startAt}
          endAt={endAt}
        />
      </div>
    </>
  );
};

export default GetAllLookUpData;
